// extracted by mini-css-extract-plugin
export default {"input_search":"Search_input_search__hkCOu","button_search":"Search_button_search__Go1v4","flex_search_container":"Search_flex_search_container__DiMty"};